// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "web-app-adapter .web-app-adapter{width:100%;display:block}", "",{"version":3,"sources":["webpack://./src/components/web-app-adapter/style.scss"],"names":[],"mappings":"AACI,iCACI,UAAA,CACA,aAAA","sourcesContent":["web-app-adapter {\n    .web-app-adapter {\n        width: 100%;\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
